import { render, staticRenderFns } from "./LayoutExternal.vue?vue&type=template&id=90d12824&"
import script from "./LayoutExternal.vue?vue&type=script&lang=js&"
export * from "./LayoutExternal.vue?vue&type=script&lang=js&"
import style0 from "./LayoutExternal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports